/**
 * Split pasted story body into paragraphs (blank line = new paragraph).
 */
export function splitParagraphs(text) {
  if (!text || !String(text).trim()) return [];
  const normalized = String(text)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim();

  if (/\n\s*\n/.test(normalized)) {
    return normalized
      .split(/\n\s*\n+/)
      .map((p) => p.trim())
      .filter(Boolean);
  }

  if (normalized.includes('\n')) {
    return normalized
      .split(/\n/)
      .map((p) => p.trim())
      .filter(Boolean);
  }

  return [normalized];
}

/** First paragraph or truncated plain text for card previews */
export function excerptCardPreview(text, maxLen = 160) {
  const paras = splitParagraphs(text);
  const first = paras[0] || '';
  if (first.length <= maxLen) return first;
  return `${first.slice(0, maxLen).trim()}…`;
}
